"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, Flex, FlexCenter, Form, Separator } from "@opensea/ui-kit";
import { useState } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { BackButton } from "../../../components/BackButton/BackButton";
import { Button } from "../../../components/Button";
import { useAllActionsCompleted } from "../../hooks/useAllActionsCompleted";
import { useSetBlockchainActionErrors } from "../../hooks/useSetBlockchainActionErrors";
import { CancelOrderFlowContentFragment } from "./CancelOrderFlowContent.fragment";
import { CancelOrderActionTimeline } from "./components/CancelOrderActionTimeline/CancelOrderActionTimeline";
import { CancelOrderFlowStatus } from "./components/CancelOrderFlowStatus";
import { CancelOrderTable } from "./components/CancelOrderTable";
import { GaslessCancelOrderStatus } from "./components/GaslessCancelOrderStatus";
export const CancelOrderFlowContent = t0 => {
  const $ = _c(27);
  const {
    data: dataKey,
    gaslessCancelEligibleOrders,
    onForceOnchainCancellation
  } = t0;
  const t = useTranslations("wallet.CancelOrderFlow");
  const data = readFragment(CancelOrderFlowContentFragment, dataKey);
  const [view, setView] = useState("review");
  const [gaslessCancelSignatureMap, setGaslessCancelSignatureMap] = useState();
  useSetBlockchainActionErrors(data.errors);
  const [allActionsCompleted] = useAllActionsCompleted();
  const actions = data.actions;
  const cancelOrderAction = actions.flatMap(_temp)[0];
  const gaslessCancelOrderAction = actions.flatMap(_temp2)[0];
  const hasGaslessCancelOrders = gaslessCancelEligibleOrders && !!gaslessCancelOrderAction;
  const orders = hasGaslessCancelOrders ? gaslessCancelOrderAction.orders : cancelOrderAction.orders;
  const methods = useForm({
    defaultValues: {
      orders: orders.map(_temp3)
    },
    mode: "onChange"
  });
  const {
    handleSubmit
  } = methods;
  let t1;
  if ($[0] !== methods.control) {
    t1 = {
      control: methods.control,
      name: "orders"
    };
    $[0] = methods.control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formOrders = useWatch(t1);
  let t2;
  if ($[2] !== setView) {
    t2 = () => {
      setView("review");
    };
    $[2] = setView;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onSubmit = t2;
  if (!orders.length) {
    return null;
  }
  const tableOrders = formOrders.flatMap(formOrder => {
    const matchedOrder = orders.find(order => order.id === formOrder.id);
    return matchedOrder ? [matchedOrder] : [];
  });
  if (view === "done" && !hasGaslessCancelOrders && allActionsCompleted) {
    return <FormProvider {...methods}><CancelOrderFlowStatus orders={orders} /></FormProvider>;
  }
  if (view === "done" && hasGaslessCancelOrders) {
    let t3;
    if ($[4] !== onForceOnchainCancellation || $[5] !== setGaslessCancelSignatureMap || $[6] !== setView) {
      t3 = () => {
        setGaslessCancelSignatureMap(undefined);
        onForceOnchainCancellation?.();
        setView("cancel");
      };
      $[4] = onForceOnchainCancellation;
      $[5] = setGaslessCancelSignatureMap;
      $[6] = setView;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return <FormProvider {...methods}><GaslessCancelOrderStatus action={gaslessCancelOrderAction} forceOnchainCancellation={t3} signatureMap={gaslessCancelSignatureMap} /></FormProvider>;
  }
  let t3;
  if ($[8] !== handleSubmit || $[9] !== onSubmit) {
    t3 = handleSubmit(onSubmit);
    $[8] = handleSubmit;
    $[9] = onSubmit;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== setView || $[12] !== view) {
    t4 = view === "review" ? <><BackButton onClick={() => setView("cancel")} /><Separator className="h-4 text-secondary" orientation="vertical" /></> : null;
    $[11] = setView;
    $[12] = view;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== tableOrders || $[15] !== view) {
    t5 = <BottomSheetBody><CancelOrderTable orders={tableOrders} view={view} /></BottomSheetBody>;
    $[14] = tableOrders;
    $[15] = view;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const T0 = BottomSheetFooter;
  const t6 = view === "cancel" ? <Flex className="justify-end"><Button type="submit" variant="destructive">{t(orders[0].side === "LISTING" ? "cancelListing" : "cancelOffer", {
        count: orders.length
      })}</Button></Flex> : null;
  let t7;
  if ($[17] !== gaslessCancelEligibleOrders || $[18] !== setGaslessCancelSignatureMap || $[19] !== setView || $[20] !== tableOrders || $[21] !== view) {
    t7 = view === "review" ? <CancelOrderActionTimeline gaslessCancelEligibleOrders={Boolean(gaslessCancelEligibleOrders)} orderIds={tableOrders.map(_temp4)} setGaslessCancelSignatureMap={setGaslessCancelSignatureMap} setView={setView} /> : null;
    $[17] = gaslessCancelEligibleOrders;
    $[18] = setGaslessCancelSignatureMap;
    $[19] = setView;
    $[20] = tableOrders;
    $[21] = view;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== T0 || $[24] !== t6 || $[25] !== t7) {
    t8 = <T0>{t6}{t7}</T0>;
    $[23] = T0;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return <FormProvider {...methods}><Form onSubmit={t3}><BottomSheetHeader><BottomSheetHeaderTitle><FlexCenter className="gap-3">{t4}<h3>{t(orders[0].side === "LISTING" ? "cancelListing" : "cancelOffer", {
                count: orders.length
              })}</h3></FlexCenter></BottomSheetHeaderTitle></BottomSheetHeader>{t5}{t8}</Form></FormProvider>;
};
function _temp(a) {
  return a.__typename === "CancelOrdersAction" ? [a] : [];
}
function _temp2(a_0) {
  return a_0.__typename === "GaslessCancelOrdersAction" ? [a_0] : [];
}
function _temp3(o) {
  return {
    id: o.id
  };
}
function _temp4(o_0) {
  return o_0.id;
}